import { render, staticRenderFns } from "./relanceUtilisateur.vue?vue&type=template&id=66945ea0"
import script from "./relanceUtilisateur.vue?vue&type=script&lang=js"
export * from "./relanceUtilisateur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports